import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { analysisData, loadAnalysisData, loaduserData, setAuthentication, isAuthenticated, userData } from '../Redux/Slices/adminPortalSlice';
import { firebaseServices } from '../Firebase/FirebaseServices';
import AdminLogin from './LoginPage/AdminLogin';
import DashboardPage from './DashboardPage/DashboardPage';


function AdminPortal() {
    // let [authenticated, setAuthenticated] = useState(false);
    let dispatch = useDispatch();
    let authStatus = useSelector(isAuthenticated)
    let data = useSelector(analysisData)
    let userDetails = useSelector(userData)

    useEffect(() => {
        // check if user is logged in?
        // if logged in, then get relevent data from firebase and store it in central place
        firebaseServices.auth().onAuthStateChanged(function (user) {
            if (user && user.isAnonymous === false && user.uid === 'mpJL5hflVOfmT6AdHPx7SxxlReK2') {
                // console.log('-- -- --');
                // console.log(user.uid);
                // setAuthenticated(true);
                dispatch(setAuthentication(true));
                if( data === 'unloaded' ){
                fetch("https://us-central1-sairaneedshelp.cloudfunctions.net/getdata/analysis")
                .then(res =>  res.json())
                    .then((data) => {
                        // console.log('I--- ---- -- - --- - - - -I')
                        // console.log(data)
                        dispatch(loadAnalysisData(data))
                    })
                    .catch((error) => {
                        // alert(error)
                    });
                }

                if(userDetails === 'unloaded' ){
                    fetch("https://us-central1-sairaneedshelp.cloudfunctions.net/getdata/userdetails")
                    .then(res =>  res.json())
                        .then((data) => {
                            // console.log('INNN--- ---- -- - --- - - - -I')
                            // console.log(data)
                            dispatch(loaduserData(data))
                        })
                        .catch((error) => {
                            // alert(error)
                        });
                    }

            } else {
                // console.log('used is NOT signed in')
            }

        });

    },[])

    if (authStatus === true) {
        return (<DashboardPage />)
    } else {
        return (<AdminLogin />)
    }
}

export default AdminPortal;

{/* <button onClick={() => {
    firebaseServices.auth().signInWithEmailAndPassword('zaeem123@live.com', '123456')
        .then((e) => {
            console.log(e)
        })
        .catch((error) => { console.log(error) })
}}>sign in</button> */}